import { Attrs, MinzeElement } from 'minze'

export interface LvcNotificationIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcNotificationIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 33],
    ['data-height', 32],
  ]
  html = () => `
  <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.5349 24.4541C12.5349 27.3589 14.5745 28.861 16.619 28.9925C18.6634 29.124 20.7018 27.5109 20.7018 24.6293M17.7325 5.7899C10.6975 5.76771 8.45308 15.2267 8.21271 20.0176C6.97563 20.5748 6.0539 21.9295 5.49891 23.0636C5.20659 23.661 5.66279 24.3067 6.32771 24.321L26.6697 24.7573C27.3354 24.7715 27.8148 24.1433 27.5078 23.5525C26.711 22.0195 25.3534 20.6244 24.6413 20.0176C25.4339 15.447 25.2452 6.30155 18.2775 5.8101M17.7325 5.7899C17.8198 5.79018 17.9079 5.79192 17.9968 5.79514C18.0916 5.79859 18.1851 5.80358 18.2775 5.8101M17.7325 5.7899V3.94287H18.0774L18.2775 5.8101" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
  </svg>
  
  `

  css = () => `
    
  `
}
